<div class="check-lists-question">
  <div class="check-lists-question__content">
    <app-checkbox class="check-lists-question__check" [disabled]="control.disabled">
      <input type="checkbox" [formControl]="control" />
      <checkbox-text>{{ question.text }}</checkbox-text>
    </app-checkbox>

    <div *ngIf="isChecklist" class="check-lists-question__sorting" [class.check-lists-question__sorting--disabled]="control.disabled">
      <app-icon [size]="'18'" [glyph]="'arrow-top-2'" class="check-lists-question__up" title="Переместить выше" (click)="sorted.emit(sortDirection.Up)"> </app-icon>
      <app-icon [size]="'18'" [glyph]="'arrow-down-2'" class="check-lists-question__down" (click)="sorted.emit(sortDirection.Down)" title="Переместить ниже"> </app-icon>
    </div>
    <div class="check-lists-question__required" *ngIf="isChecklist">
      <app-switch [formControl]="requiredControl" (changed)="handleChange($event)"> Обязательный вопрос </app-switch>
    </div>
  </div>
  <div class="check-lists-question__actions"
       [class.check-lists-question__actions--disabled]="control.disabled"
       [ngSwitch]="question.type">
    <app-bool-answer *ngSwitchCase="questionTypes.Bool"></app-bool-answer>
    <app-string-answer *ngSwitchCase="questionTypes.String"></app-string-answer>
    <app-choices-multiple-answer [question]="question" *ngSwitchCase="questionTypes.ChoicesMultiple"></app-choices-multiple-answer>
    <app-choices-multiple-answer [question]="question" [withComment]="true" *ngSwitchCase="questionTypes.ChoicesMultipleWithComment"></app-choices-multiple-answer>
    <app-choices-answer [question]="question" *ngSwitchCase="questionTypes.Choices"></app-choices-answer>
    <app-coordinate-answer *ngSwitchCase="questionTypes.Coordinate"></app-coordinate-answer>
    <app-camera-answer *ngSwitchCase="questionTypes.Camera"></app-camera-answer>
    <app-image-answer *ngSwitchCase="questionTypes.Image"></app-image-answer>
    <app-camera-answer *ngSwitchCase="questionTypes.Camera5" [count]="5" [withComment]="true"></app-camera-answer>
    <app-camera-answer *ngSwitchCase="questionTypes.Camera10" [count]="10" [withComment]="true"></app-camera-answer>
    <app-image-answer *ngSwitchCase="questionTypes.Image5" [count]="5" [withComment]="true"></app-image-answer>
    <app-image-answer *ngSwitchCase="questionTypes.Image10" [count]="10" [withComment]="true"></app-image-answer>
    <app-integer-answer *ngSwitchCase="questionTypes.Integer"></app-integer-answer>
    <app-quality-keeper-answer *ngSwitchCase="questionTypes.QualityKeeper"></app-quality-keeper-answer>
    <app-port-answer *ngSwitchCase="questionTypes.Port"></app-port-answer>
    <app-speedtest-answer *ngSwitchCase="questionTypes.Speedtest"></app-speedtest-answer>
  </div>
  <button *ngIf="canMove" (click)="moved.emit(question)" class="check-lists-question__move-bar" title="Переместить">
    <app-icon class="check-lists-question__move-bar-icon" [glyph]="'arrow-right-2'" [size]="'10'" [color]="'gray-dark'"></app-icon>
  </button>
</div>
